
import React from 'react';
import { useOfflineStatus } from '@/context/offline/OfflineProvider';

// This component intentionally left empty since we now handle network status
// via the floating badges in OfflineProvider
const NetworkStatus = () => {
  return null;
};

export default NetworkStatus;
